import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/collapse-item.scss';
//# sourceMappingURL=index.mjs.map
